














































import Vue, { PropType } from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Rates from "@/components/Molecules/Rates/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import CompanyLogo from "@/components/Atoms/CompanyLogo/index.vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "CompetitorSearchList",
  components: {
    Heading,
    Rates,
    Button,
    CompanyLogo
  },
  props: {
    company: {
      type: Object as PropType<Props["company"]>,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleDeleteCompetitorClick() {
      this.$emit("deleteCompetitor");
    },
    handleAddCompetitorClick() {
      this.$emit("addCompetitor");
    }
  }
});
